import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { UserIcon, SettingsIcon, CompassIcon, BellIcon, CalendarIcon, ArrowRightIcon, ThumbsUpIcon, LayoutDashboardIcon, TagIcon, StarIcon, TicketIcon, XIcon } from 'lucide-react';
interface PersonalizedSectionProps {
  username?: string;
}
const PersonalizedSection: React.FC<PersonalizedSectionProps> = ({
  username = 'Guest'
}) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [interests, setInterests] = useState<string[]>(['Technology', 'Running', 'Food']);
  const [recentActivity, setRecentActivity] = useState([{
    type: 'event',
    name: 'Nairobi Tech Meetup',
    date: '3 days ago'
  }, {
    type: 'community',
    name: 'WeRun Nairobi',
    date: '1 week ago'
  }]);
  const recommendations = [{
    id: '1',
    name: 'Nairobi Photography Club',
    members: 234,
    category: 'Photography'
  }, {
    id: '2',
    name: 'Kenyan Foodies',
    members: 567,
    category: 'Food & Dining'
  }, {
    id: '3',
    name: 'AI Kenya',
    members: 189,
    category: 'Technology'
  }];
  const upcomingEvents = [{
    id: '1',
    name: 'Weekend Hike - Ngong Hills',
    date: 'Oct 15, 2023'
  }, {
    id: '2',
    name: 'Tech Startup Networking',
    date: 'Oct 18, 2023'
  }];
  // Preferences modal state
  const [showPreferences, setShowPreferences] = useState(false);
  const [selectedTags, setSelectedTags] = useState<string[]>(['Technology', 'Running', 'Food']);
  const availableTags = ['Technology', 'Running', 'Food', 'Art', 'Music', 'Books', 'Travel', 'Photography', 'Sports', 'Fitness', 'Cooking', 'Fashion', 'Movies', 'Gaming', 'Education', 'Business', 'Networking', 'Outdoors', 'Wellness', 'Science'];
  const toggleTag = (tag: string) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter(t => t !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };
  const savePreferences = () => {
    setInterests(selectedTags);
    setShowPreferences(false);
  };
  return <div className="border border-gray-300 rounded-lg p-4 mb-6" data-id="element-254">
      <div className="flex items-center justify-between mb-4" data-id="element-255">
        <h2 className="text-lg font-bold" data-id="element-256">Your JoinToday Dashboard</h2>
        <button onClick={() => setShowPreferences(true)} className="flex items-center text-sm hover:bg-gray-100 dark:hover:bg-gray-700 px-2 py-1 rounded-md" data-id="element-257">
          <SettingsIcon className="w-4 h-4 mr-1" data-id="element-258" />
          <span data-id="element-259">Preferences</span>
        </button>
      </div>

      {!isLoggedIn ? <div className="text-center py-6 border border-dashed border-gray-300 rounded-lg mb-4" data-id="element-260">
          <UserIcon className="w-12 h-12 mx-auto mb-2 text-gray-400" data-id="element-261" />
          <h3 className="font-medium mb-2" data-id="element-262">Welcome to JoinToday!</h3>
          <p className="text-sm text-gray-600 mb-4" data-id="element-263">
            Sign in to get personalized recommendations and track your
            communities.
          </p>
          <div className="flex justify-center space-x-3" data-id="element-264">
            <button onClick={() => setIsLoggedIn(true)} className="bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800 rounded-md px-4 py-2 text-sm" data-id="element-265">
              Sign In
            </button>
            <Link to="/register" className="border border-gray-300 rounded-md px-4 py-2 text-sm" data-id="element-266">
              Register
            </Link>
          </div>
        </div> : <>
          <div className="flex items-center p-3 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-lg mb-4" data-id="element-267">
            <div className="w-10 h-10 bg-white dark:bg-gray-800 rounded-full flex items-center justify-center mr-3" data-id="element-268">
              <span className="text-lg font-bold text-gray-800 dark:text-white" data-id="element-269">
                JD
              </span>
            </div>
            <div data-id="element-270">
              <h3 className="font-medium" data-id="element-271">Welcome back, John!</h3>
              <p className="text-sm opacity-90" data-id="element-272">
                Last visit: Yesterday at 4:30 PM
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-273">
            <div className="border border-gray-300 rounded-lg p-3" data-id="element-274">
              <div className="flex items-center mb-2" data-id="element-275">
                <StarIcon className="w-4 h-4 mr-2 text-gray-800 dark:text-gray-200" data-id="element-276" />
                <h3 className="font-medium" data-id="element-277">Your JT Points</h3>
              </div>
              <p className="text-2xl font-bold" data-id="element-278">180</p>
              <div className="flex items-center mt-1 text-xs" data-id="element-279">
                <span className="text-gray-800 dark:text-gray-200" data-id="element-280">
                  +25 points
                </span>
                <span className="mx-1" data-id="element-281">•</span>
                <span data-id="element-282">Last 7 days</span>
              </div>
            </div>
            <div className="border border-gray-300 rounded-lg p-3" data-id="element-283">
              <div className="flex items-center mb-2" data-id="element-284">
                <BellIcon className="w-4 h-4 mr-2 text-gray-800 dark:text-gray-200" data-id="element-285" />
                <h3 className="font-medium" data-id="element-286">Notifications</h3>
              </div>
              <p className="text-2xl font-bold" data-id="element-287">3</p>
              <Link to="/profile" className="text-xs text-gray-800 dark:text-gray-200 flex items-center mt-1" data-id="element-288">
                View all notifications
                <ArrowRightIcon className="w-3 h-3 ml-1" data-id="element-289" />
              </Link>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-3 mb-4" data-id="element-290">
            <h3 className="font-medium mb-2" data-id="element-291">Your Interests</h3>
            <div className="flex flex-wrap gap-2" data-id="element-292">
              {interests.map((interest, index) => <div key={index} className="flex items-center bg-gray-100 dark:bg-gray-700 rounded-full px-3 py-1" data-id="element-293">
                  <span className="text-sm" data-id="element-294">{interest}</span>
                  <button className="ml-2 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300" onClick={() => {
              setInterests(interests.filter(i => i !== interest));
              setSelectedTags(selectedTags.filter(t => t !== interest));
            }} data-id="element-295">
                    <span className="text-xs" data-id="element-296">×</span>
                  </button>
                </div>)}
              <button className="border border-dashed border-gray-300 rounded-full px-3 py-1 text-sm flex items-center" onClick={() => setShowPreferences(true)} data-id="element-297">
                <span className="text-xs mr-1" data-id="element-298">+</span> Add interest
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-299">
            <div data-id="element-300">
              <div className="flex items-center justify-between mb-2" data-id="element-301">
                <h3 className="font-medium" data-id="element-302">Recommended For You</h3>
                <Link to="/communities" className="text-xs text-gray-800 dark:text-gray-200" data-id="element-303">
                  View all
                </Link>
              </div>
              <div className="space-y-2" data-id="element-304">
                {recommendations.map(item => <div key={item.id} className="border border-gray-300 rounded-lg p-2" data-id="element-305">
                    <h4 className="font-medium text-sm" data-id="element-306">{item.name}</h4>
                    <div className="flex items-center justify-between text-xs text-gray-500 mt-1" data-id="element-307">
                      <span data-id="element-308">{item.members} members</span>
                      <span className="bg-gray-100 dark:bg-gray-700 px-2 py-0.5 rounded-full" data-id="element-309">
                        {item.category}
                      </span>
                    </div>
                  </div>)}
              </div>
            </div>
            <div data-id="element-310">
              <div className="flex items-center justify-between mb-2" data-id="element-311">
                <h3 className="font-medium" data-id="element-312">Upcoming Events</h3>
                <Link to="/events" className="text-xs text-gray-800 dark:text-gray-200" data-id="element-313">
                  View all
                </Link>
              </div>
              <div className="space-y-2" data-id="element-314">
                {upcomingEvents.map(event => <div key={event.id} className="border border-gray-300 rounded-lg p-2" data-id="element-315">
                    <h4 className="font-medium text-sm" data-id="element-316">{event.name}</h4>
                    <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-317">
                      <CalendarIcon className="w-3 h-3 mr-1" data-id="element-318" />
                      <span data-id="element-319">{event.date}</span>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </>}

      <div className="mt-4 pt-3 border-t border-gray-200" data-id="element-320">
        <div className="flex justify-between items-center mb-2" data-id="element-321">
          <h3 className="font-medium" data-id="element-322">Quick Links</h3>
        </div>
        <div className="grid grid-cols-5 gap-2" data-id="element-323">
          <Link to="/daily-vibe-check" className="flex flex-col items-center p-2 border border-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-324">
            <LayoutDashboardIcon className="w-5 h-5 mb-1" data-id="element-325" />
            <span className="text-xs text-center" data-id="element-326">Daily Vibe Check</span>
          </Link>
          <Link to="/communities" className="flex flex-col items-center p-2 border border-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-327">
            <CompassIcon className="w-5 h-5 mb-1" data-id="element-328" />
            <span className="text-xs text-center" data-id="element-329">Explore</span>
          </Link>
          <Link to="/events" className="flex flex-col items-center p-2 border border-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-330">
            <CalendarIcon className="w-5 h-5 mb-1" data-id="element-331" />
            <span className="text-xs text-center" data-id="element-332">Events</span>
          </Link>
          <Link to="/tickets" className="flex flex-col items-center p-2 border border-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-333">
            <TicketIcon className="w-5 h-5 mb-1" data-id="element-334" />
            <span className="text-xs text-center" data-id="element-335">Tickets</span>
          </Link>
          <Link to="/deals-discounts" className="flex flex-col items-center p-2 border border-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-336">
            <TagIcon className="w-5 h-5 mb-1" data-id="element-337" />
            <span className="text-xs text-center" data-id="element-338">Deals</span>
          </Link>
        </div>
      </div>

      {/* Preferences Modal */}
      {showPreferences && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-339">
          <div className="bg-white dark:bg-gray-800 rounded-lg w-full max-w-lg max-h-[90vh] overflow-auto" data-id="element-340">
            <div className="flex justify-between items-center p-4 border-b border-gray-200 dark:border-gray-700" data-id="element-341">
              <h3 className="text-lg font-bold" data-id="element-342">Your Preferences</h3>
              <button onClick={() => setShowPreferences(false)} className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-343">
                <XIcon className="w-5 h-5" data-id="element-344" />
              </button>
            </div>
            <div className="p-4" data-id="element-345">
              <div className="mb-4" data-id="element-346">
                <h4 className="font-medium mb-2" data-id="element-347">Select Your Interests</h4>
                <p className="text-sm text-gray-500 dark:text-gray-400 mb-3" data-id="element-348">
                  Choose topics you're interested in to personalize your
                  experience.
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-349">
                  {availableTags.map(tag => <button key={tag} onClick={() => toggleTag(tag)} className={`px-3 py-1 rounded-full text-sm ${selectedTags.includes(tag) ? 'bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800' : 'bg-gray-100 dark:bg-gray-700'}`} data-id="element-350">
                      {tag}
                    </button>)}
                </div>
              </div>
              <div className="mb-4" data-id="element-351">
                <h4 className="font-medium mb-2" data-id="element-352">Notification Preferences</h4>
                <div className="space-y-2" data-id="element-353">
                  <div className="flex items-center justify-between" data-id="element-354">
                    <span className="text-sm" data-id="element-355">Email notifications</span>
                    <div className="w-10 h-5 bg-gray-200 dark:bg-gray-700 rounded-full relative" data-id="element-356">
                      <div className="absolute left-0.5 top-0.5 w-4 h-4 bg-white dark:bg-gray-200 rounded-full" data-id="element-357"></div>
                    </div>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-358">
                    <span className="text-sm" data-id="element-359">Push notifications</span>
                    <div className="w-10 h-5 bg-gray-800 dark:bg-gray-200 rounded-full relative" data-id="element-360">
                      <div className="absolute right-0.5 top-0.5 w-4 h-4 bg-white dark:bg-gray-800 rounded-full" data-id="element-361"></div>
                    </div>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-362">
                    <span className="text-sm" data-id="element-363">Event reminders</span>
                    <div className="w-10 h-5 bg-gray-800 dark:bg-gray-200 rounded-full relative" data-id="element-364">
                      <div className="absolute right-0.5 top-0.5 w-4 h-4 bg-white dark:bg-gray-800 rounded-full" data-id="element-365"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-4" data-id="element-366">
                <h4 className="font-medium mb-2" data-id="element-367">Privacy Settings</h4>
                <div className="space-y-2" data-id="element-368">
                  <div className="flex items-center justify-between" data-id="element-369">
                    <span className="text-sm" data-id="element-370">Show my profile to everyone</span>
                    <div className="w-10 h-5 bg-gray-800 dark:bg-gray-200 rounded-full relative" data-id="element-371">
                      <div className="absolute right-0.5 top-0.5 w-4 h-4 bg-white dark:bg-gray-800 rounded-full" data-id="element-372"></div>
                    </div>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-373">
                    <span className="text-sm" data-id="element-374">Allow others to tag me</span>
                    <div className="w-10 h-5 bg-gray-800 dark:bg-gray-200 rounded-full relative" data-id="element-375">
                      <div className="absolute right-0.5 top-0.5 w-4 h-4 bg-white dark:bg-gray-800 rounded-full" data-id="element-376"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-end p-4 border-t border-gray-200 dark:border-gray-700" data-id="element-377">
              <button onClick={() => setShowPreferences(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md mr-2" data-id="element-378">
                Cancel
              </button>
              <button onClick={savePreferences} className="px-4 py-2 bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800 rounded-md" data-id="element-379">
                Save Preferences
              </button>
            </div>
          </div>
        </div>}
    </div>;
};
export default PersonalizedSection;